<template>
  <el-dialog
    title="查看库存快照"
    :visible.sync="dialogVisible"
    width="920px"
    custom-class="inventory-check-snapshot-dialog"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="snapshot-meta" v-if="meta.planId">
      <span>盘库单号：{{ meta.planId }}</span>
      <span>计划日期：{{ meta.planDate || "-" }}</span>
      <span>状态：{{ meta.statusLabel || "-" }}</span>
      <span>范围：{{ meta.productTypeSummary || "-" }} / {{ meta.purchaseColorSummary || "-" }}</span>
    </div>

    <el-tabs v-model="bookQtyTab" class="book-qty-tabs" @tab-click="onBookQtyTabChange">
      <el-tab-pane name="nonzero">
        <span slot="label">本地库存!=0（{{ nonzeroCount }}）</span>
      </el-tab-pane>
      <el-tab-pane name="zero">
        <span slot="label">本地库存=0（{{ zeroCount }}）</span>
      </el-tab-pane>
      <el-tab-pane name="all">
        <span slot="label">全部（{{ allCount }}）</span>
      </el-tab-pane>
    </el-tabs>

    <el-table
      :data="tableData"
      border
      stripe
      size="mini"
      max-height="420"
      v-loading="loading"
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column label="序号" width="55" align="center">
        <template slot-scope="scope">{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="shopName" label="店铺" width="50" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="productName" label="产品名称" width="140" show-overflow-tooltip></el-table-column>
      <el-table-column prop="purchaseColorName" label="采购颜色" width="80" align="left" show-overflow-tooltip></el-table-column>
      <el-table-column prop="model" label="型号" width="90" align="left" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.model || "-" }}</template>
      </el-table-column>
      <el-table-column prop="fnsku" label="FNSKU" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.fnsku || "-" }}</template>
      </el-table-column>
      <el-table-column prop="bookQty" label="本地库存" width="70" align="right"></el-table-column>
      <el-table-column prop="inPurchase" label="采购中" width="70" align="right"></el-table-column>
      <el-table-column min-width="80" label="备注"></el-table-column>
    </el-table>

    <div class="snapshot-pagination" v-if="total > pageSize">
      <el-pagination
        layout="prev, pager, next"
        background
        prev-text="上一页"
        next-text="下一页"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="onPageChange"
      ></el-pagination>
    </div>

    <!-- 打印区域：对标出库单 vue-print-nb；打印当前 Tab 过滤结果 -->
    <div class="plan-conent inventory-check-snapshot-print" id="inventory-check-snapshot-print" style="padding: 10px">
      <div class="title-content">
        <span class="title-label">盘库单号：</span>
        <span class="title-text">{{ meta.planId || "" }}</span>
        <span class="title-label" style="margin-left: 20px">计划日期：</span>
        <span class="title-text">{{ meta.planDate || "" }}</span>
        <span class="title-label" style="margin-left: 20px">产品范围：</span>
        <span class="title-text">{{ meta.productTypeSummary || "" }}</span>
      </div>
      <el-table
        :data="printData"
        border
        size="mini"
        show-summary
        :summary-method="getPrintSummaries"
        style="font-size: 12px; font-weight: bold; border-color: gray"
      >
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="shopName" label="店铺" width="50px" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品名称" width="140px"></el-table-column>
        <el-table-column prop="purchaseColorName" label="采购颜色" width="80px" align="center"></el-table-column>
        <el-table-column prop="model" label="型号" width="90px" align="left"></el-table-column>
        <el-table-column prop="fnsku" label="FNSKU" width="120px"></el-table-column>
        <el-table-column prop="bookQty" label="本地库存" width="70px" align="right"></el-table-column>
        <el-table-column prop="inPurchase" label="采购中" width="70px" align="right"></el-table-column>
        <el-table-column min-width="80" label="备注"></el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
      <el-button
        class="opreate-btn"
        type="primary"
        size="small"
        icon="el-icon-printer"
        :loading="loading"
        :disabled="!printData.length"
        v-print="'#inventory-check-snapshot-print'"
      >
        打 印
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import request from "../../request/requestModules.js";

export default {
  name: "InventoryCheckSnapshotDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      allData: [],
      meta: {},
      inventoryCheckId: "",
      bookQtyTab: "nonzero",
      currentPage: 1,
      pageSize: 50,
    };
  },
  computed: {
    nonzeroCount() {
      return (this.allData || []).filter(row => Number(row.bookQty) !== 0).length;
    },
    zeroCount() {
      return (this.allData || []).filter(row => Number(row.bookQty) === 0).length;
    },
    allCount() {
      return (this.allData || []).length;
    },
    filteredAllData() {
      const list = this.allData || [];
      if (this.bookQtyTab === "zero") {
        return list.filter(row => Number(row.bookQty) === 0);
      }
      if (this.bookQtyTab === "all") {
        return list;
      }
      return list.filter(row => Number(row.bookQty) !== 0);
    },
    total() {
      return this.filteredAllData.length;
    },
    tableData() {
      const begin = (this.currentPage - 1) * this.pageSize;
      return this.filteredAllData.slice(begin, begin + this.pageSize);
    },
    printData() {
      return this.filteredAllData;
    },
  },
  methods: {
    open(row) {
      if (!row || !(row.id || row._id)) {
        this.$message.warning("请选择盘库计划");
        return;
      }
      this.inventoryCheckId = String(row.id || row._id);
      this.dialogVisible = true;
      this.bookQtyTab = "nonzero";
      this.currentPage = 1;
      this.meta = {
        planId: row.planId || "",
        planDate: row.planDate || "",
        statusLabel: row.statusLabel || "",
        productTypeSummary: row.productTypeSummary || "",
        purchaseColorSummary: row.purchaseColorSummary || "",
      };
      this.loadAll();
    },
    handleClose() {
      this.allData = [];
      this.meta = {};
      this.inventoryCheckId = "";
      this.bookQtyTab = "nonzero";
      this.currentPage = 1;
    },
    onBookQtyTabChange() {
      this.currentPage = 1;
    },
    onPageChange(page) {
      this.currentPage = page;
    },
    loadAll() {
      if (!this.inventoryCheckId) return;
      this.loading = true;
      request
        .fetchInventoryCheckDetails({
          id: this.inventoryCheckId,
          beginIndex: 0,
          pageSize: 100000,
        })
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "获取库存快照失败");
            this.allData = [];
            return;
          }
          this.allData = res.ldata || [];
          if (res.mdata) {
            this.meta = {
              ...this.meta,
              planId: res.mdata.planId || this.meta.planId,
              planDate: res.mdata.planDate || this.meta.planDate,
              statusLabel: res.mdata.statusLabel || this.meta.statusLabel,
              productTypeSummary: res.mdata.productTypeSummary || this.meta.productTypeSummary,
              purchaseColorSummary: res.mdata.purchaseColorSummary || this.meta.purchaseColorSummary,
            };
          }
          if (!this.allData.length) {
            this.$message.info("暂无库存快照，请先开始盘库");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取库存快照失败");
          this.allData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "bookQty") {
          sums[index] = (data || []).reduce((s, row) => s + (Number(row.bookQty) || 0), 0);
          return;
        }
        if (column.property === "inPurchase") {
          sums[index] = (data || []).reduce((s, row) => s + (Number(row.inPurchase) || 0), 0);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    getPrintSummaries(param) {
      return this.getSummaries(param);
    },
  },
};
</script>

<style lang="scss">
.inventory-check-snapshot-dialog {
  .snapshot-meta {
    margin-bottom: 10px;
    font-size: 13px;
    color: #606266;
    span {
      margin-right: 16px;
    }
  }
  .book-qty-tabs {
    margin-bottom: 8px;
    .el-tabs__header {
      margin-bottom: 8px;
    }
  }
  .snapshot-pagination {
    margin-top: 10px;
    text-align: right;
  }
  /* 屏幕上隐藏打印块，打印时由 vue-print-nb 单独输出 */
  #inventory-check-snapshot-print {
    position: absolute;
    left: -99999px;
    top: 0;
    width: 860px;
  }
}

/* 打印样式挂在 id 上：vue-print-nb 克隆节点时没有 dialog 祖先，嵌套选择器会失效 */
#inventory-check-snapshot-print {
  .title-content {
    display: inline-block;
    font-size: 14px;
    margin-right: 20px;
    height: 35px;
    line-height: 35px;
    .title-label {
      font-size: 14px;
      font-weight: bold;
    }
  }

  /* Element UI border 表外框依赖 ::before/::after，打印预览常被裁掉；补真实边框 */
  .el-table {
    overflow: visible;
  }

  .el-table--border {
    border-right: 1px solid gray !important;
    border-bottom: 1px solid gray !important;
  }

  .el-table--border::after,
  .el-table::before {
    display: none;
  }

  .el-table--mini .el-table__cell {
    border-color: gray;
  }
}
</style>
